export class SyncSettingsModel {
  public syncSettingsId: number;
  public fileURL: string;
  public description: string;
  public startDate: string;
  public frequencyCounter: number;
  public syncStartTime: string;
  public isActive: boolean;
}